/** Submenú «Nosotros» en el navbar. */
export const NAV_ABOUT_DROPDOWN = {
  label: 'Nosotros',
  items: [
    { to: '/nosotros', label: 'Quiénes somos' },
    { to: '/entes-administrativos', label: 'Entes administrativos' },
    { to: '/normatividad', label: 'Normatividad' },
  ],
};

/** Submenú «Servicios» en el navbar. */
export const NAV_SERVICES_DROPDOWN = {
  label: 'Servicios',
  items: [
    { to: '/creditos', label: 'Créditos' },
    { to: '/creditos/simulador', label: 'Simulador de crédito' },
    { to: '/convenios', label: 'Convenios' },
    { to: '/emprendimientos', label: 'Emprendimientos' },
    { to: '/sedes-vacacionales', label: 'Sedes vacacionales' },
  ],
};

/**
 * Navbar: inicio → beneficios (servicios) → institución (nosotros) → comunicación → contacto.
 */
export const PUBLIC_NAV_ITEMS = [
  { type: 'link', to: '/', label: 'Inicio' },
  { type: 'dropdown', ...NAV_SERVICES_DROPDOWN },
  { type: 'dropdown', ...NAV_ABOUT_DROPDOWN },
  { type: 'link', to: '/noticias', label: 'Noticias' },
  { type: 'link', to: '/contacto', label: 'Contacto' },
];

/** Enlaces planos para el footer (mismo orden lógico que el menú). */
export const PUBLIC_NAV_LINKS = [
  { to: '/', label: 'Inicio' },
  { to: '/creditos', label: 'Créditos' },
  { to: '/creditos/simulador', label: 'Simulador de crédito' },
  { to: '/convenios', label: 'Convenios' },
  { to: '/emprendimientos', label: 'Emprendimientos' },
  { to: '/sedes-vacacionales', label: 'Sedes vacacionales' },
  { to: '/nosotros', label: 'Quiénes somos' },
  { to: '/entes-administrativos', label: 'Entes administrativos' },
  { to: '/normatividad', label: 'Normatividad' },
  { to: '/noticias', label: 'Noticias' },
  { to: '/contacto', label: 'Contacto' },
];
